import { FullTicket } from '~/features/ticket/types/ticket';
import { everest } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

type Field = {
  fieldId: Uuid;
  value: { value: string | number | boolean | null };
};

type Request = {
  ticketId: Uuid;
  fields: Field[];
};

export const putTicket = ({
  fields,
  ticketId,
}: Request): Promise<FullTicket> => {
  return everest.put(`/tickets/${ticketId}`, {
    fields,
  });
};
